import React from 'react';
import {
    BooleanField,
    Datagrid,
    DateField,
    EmailField,
    FunctionField,
    List,
    ReferenceField,
    TextField,
} from 'react-admin';
import { DoctorReferenceField, PatientReferenceField } from "../../misc/customFields";
import {TransferSharingRequestFilter} from '../../misc/filters'

export const TransferSharingRequestList = props => {
    return (
        <div>
            <List {...props} filters={<TransferSharingRequestFilter/>}>
                <Datagrid>
                    <TextField
                        source="patient.id"
                        label="Patient ID"
                    />
                    <PatientReferenceField
                        label="Patient"
                        source="patient.id"
                        sortBy="patient"
                    />
                    <EmailField
                        source="patient.email"
                        label="Patient Email"
                    />
                    <TextField
                        label="Action Type"
                        source="action_type"
                        sortable={false}
                    />
                    <TextField
                        source="status"
                        label="Request/Invite Status"
                    />
                    <DoctorReferenceField
                        label="Clinician Owner"
                        source="owner"
                    />
                    <DoctorReferenceField
                        label="Clinician #2"
                        source="receiver"
                    />
                    <DateField
                        label="Action Date"
                        source="created"
                        showTime
                    />
                    <BooleanField source="include_notes" label="Transfered Notes" />
                </Datagrid>
            </List>
        </div>
    )
}